import { Controller } from "@hotwired/stimulus"
import { applyTheme } from "../utils/theme_transition"

// Optimistic theme flip on the sidebar radios (before turbo_stream returns).
// Connects to data-controller="theme-switch"
export default class extends Controller {
  static targets = ["value"]

  onChange(event) {
    const input = event.target
    if (!(input instanceof HTMLInputElement)) return
    if (!input.hasAttribute("data-theme-picker")) return
    if (!input.checked) return

    if (this.hasValueTarget) this.valueTarget.value = input.value

    applyTheme(input.value)

    if (this.element.requestSubmit) {
      this.element.requestSubmit()
    } else {
      this.element.submit()
    }
  }
}
